import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63f34b1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "px-6 pt-2 pb-3" }
const _hoisted_8 = { class: "d-flex justify-content-center" }
const _hoisted_9 = {
  class: "d-flex flex-wrap align-items-center justify-content-center gap-3 border rounded-3 px-3 py-2 bg-light",
  style: {"border-color":"#e9ecef"}
}
const _hoisted_10 = { class: "d-inline-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "•", -1))
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { class: "fw-semibold" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "•", -1))
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = { class: "fw-semibold" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "•", -1))
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "fw-semibold" }
const _hoisted_20 = { class: "row mb-6 mt-10" }
const _hoisted_21 = { class: "col-12 mb-2" }
const _hoisted_22 = { class: "fw-bold fs-6" }
const _hoisted_23 = {
  class: "col-12 fv-row border rounded p-4 newsletter-preview",
  style: {"background":"#f5f5f5","min-height":"250px"},
  dir: "rtl"
}
const _hoisted_24 = ["srcdoc"]
const _hoisted_25 = { class: "d-flex justify-content-center mt-10" }
const _hoisted_26 = { class: "indicator-label" }
const _hoisted_27 = { class: "indicator-progress" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_29 = { class: "d-flex justify-content-center mt-5 gap-4" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope me-2" }, null, -1))
const _hoisted_31 = { class: "indicator-progress" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_33 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_34 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  role: "dialog",
  style: {"background-color":"rgba(0, 0, 0, 0.5)"}
}
const _hoisted_35 = {
  class: "modal-dialog modal-xl",
  role: "document"
}
const _hoisted_36 = { class: "modal-content" }
const _hoisted_37 = { class: "modal-header" }
const _hoisted_38 = { class: "modal-title" }
const _hoisted_39 = { class: "px-6 pt-2 pb-3" }
const _hoisted_40 = { class: "d-flex justify-content-center" }
const _hoisted_41 = {
  class: "d-flex flex-wrap align-items-center justify-content-center gap-3 border rounded-3 px-3 py-2 bg-light",
  style: {"border-color":"#e9ecef"}
}
const _hoisted_42 = { class: "d-inline-flex align-items-center" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "•", -1))
const _hoisted_44 = { class: "text-muted" }
const _hoisted_45 = { class: "fw-semibold" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "•", -1))
const _hoisted_47 = { class: "text-muted" }
const _hoisted_48 = { class: "fw-semibold" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "•", -1))
const _hoisted_50 = { class: "text-muted" }
const _hoisted_51 = { class: "fw-semibold" }
const _hoisted_52 = {
  class: "modal-body",
  style: {"max-height":"75vh","overflow-y":"auto"}
}
const _hoisted_53 = ["srcdoc"]
const _hoisted_54 = { class: "modal-footer d-flex justify-content-end" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-footer d-flex justify-content-end py-6 px-9" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'newsletter'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('newsletterPreview')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, { class: "form" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", {
                          class: "d-inline-block rounded-circle ms-2",
                          style: _normalizeStyle({
                      width: '10px',
                      height: '10px',
                      backgroundColor:
                        _ctx.approvalStatus === 'approved' ||
                        _ctx.approvalStatus === 'pushed_mail_only'
                          ? '#198754'
                          : '#ffc107',
                    })
                        }, null, 4),
                        _createElementVNode("span", {
                          class: _normalizeClass(
                      _ctx.approvalStatus === 'approved' ||
                      _ctx.approvalStatus === 'pushed_mail_only'
                        ? 'text-success fw-semibold'
                        : 'text-warning fw-semibold'
                    )
                        }, _toDisplayString(_ctx.approvalStatus === 'approved' ||
                      _ctx.approvalStatus === 'pushed_mail_only'
                        ? _ctx.translate('approved')
                        : _ctx.translate('pending')), 3)
                      ]),
                      _hoisted_11,
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.translate('approvedBy')) + ":", 1),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(' ' + _ctx.newsletter?.approvedBy || '—'), 1)
                      ]),
                      _hoisted_14,
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.translate('approvedAt')) + ":", 1),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(' ' +
                      (_ctx.newsletter?.approvedAt
                        ? _ctx.formatDate(_ctx.newsletter?.approvedAt)
                        : '—')), 1)
                      ]),
                      _hoisted_17,
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.translate('sentPreviously')) + ":", 1),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(' ' +
                      (_ctx.approvalStatus === 'pushed_mail_only' ? 'Yes' : 'No')), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.translate('htmlPreview')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("iframe", {
                      srcdoc: _ctx.newsletter.htmlContent,
                      style: {"width":"100%","height":"500px","border":"none"}
                    }, null, 8, _hoisted_24)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                (_ctx.can('create', 'newsletter'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      ref: "submitButton",
                      class: "btn btn-success",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSubmitArchive && _ctx.onSubmitArchive(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.translate('approveAndPreview')), 1),
                      _createElementVNode("span", _hoisted_27, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_28
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_29, [
                (
              _ctx.can('create', 'newsletter') &&
              ['approved', 'pushed_mail_only'].includes(
                (_ctx.approvalStatus || '').toLowerCase()
              )
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      ref: "sendMailButton",
                      class: "btn btn-info",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sendToMail && _ctx.sendToMail(...args)))
                    }, [
                      _hoisted_30,
                      _createTextVNode(" " + _toDisplayString(_ctx.translate('sendToMail')) + " ", 1),
                      _createElementVNode("span", _hoisted_31, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_32
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1)
              ])
            ]),
            _: 1
          }),
          (_ctx.showArchivedModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("h5", _hoisted_38, _toDisplayString(_ctx.translate('archivedNewsletterPreview')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeArchivedModal && _ctx.closeArchivedModal(...args)))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("span", {
                              class: "d-inline-block rounded-circle ms-2",
                              style: _normalizeStyle({
                        width: '10px',
                        height: '10px',
                        backgroundColor:
                          _ctx.approvalStatus === 'approved' ||
                          _ctx.approvalStatus === 'pushed_mail_only'
                            ? '#198754'
                            : '#ffc107',
                      })
                            }, null, 4),
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        _ctx.approvalStatus === 'approved' ||
                        _ctx.approvalStatus === 'pushed_mail_only'
                          ? 'text-success fw-semibold'
                          : 'text-warning fw-semibold'
                      )
                            }, _toDisplayString(_ctx.approvalStatus === 'approved' ||
                        _ctx.approvalStatus === 'pushed_mail_only'
                          ? _ctx.translate('approved')
                          : _ctx.translate('pending')), 3)
                          ]),
                          _hoisted_43,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.translate('approvedBy')) + ":", 1),
                            _createElementVNode("span", _hoisted_45, _toDisplayString(' ' + _ctx.approvedBy || '—'), 1)
                          ]),
                          _hoisted_46,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.translate('approvedAt')) + ":", 1),
                            _createElementVNode("span", _hoisted_48, _toDisplayString(' ' + (_ctx.approvedAt ? _ctx.formatDate(_ctx.approvedAt) : '—')), 1)
                          ]),
                          _hoisted_49,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.translate('sentPreviously')) + ":", 1),
                            _createElementVNode("span", _hoisted_51, _toDisplayString(' ' +
                        (_ctx.approvalStatus === 'pushed_mail_only' ? 'Yes' : '—')), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("iframe", {
                        srcdoc: _ctx.archivedHtmlContent,
                        style: {"width":"100%","height":"500px","border":"none"}
                      }, null, 8, _hoisted_53)
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      (
                  _ctx.approvalStatus !== 'approved' &&
                  _ctx.approvalStatus !== 'pushed_mail_only'
                )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-success",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.approveNewsletter && _ctx.approveNewsletter(...args)))
                          }, _toDisplayString(_ctx.translate('approve')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "reset",
                        class: "btn btn-white btn-active-light-primary me-2",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeArchivedModal && _ctx.closeArchivedModal(...args)))
                      }, _toDisplayString(_ctx.translate('discard')), 1),
                      _hoisted_55
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}